// Safari / the iOS app's web view can't loop over a ReadableStream with `for await`,
// which pdf.js uses to read a PDF's text (Quick edit, quizzes from PDFs). Add it where missing.
type RS = { getReader: () => { read: () => Promise<{ done: boolean; value?: unknown }>; releaseLock: () => void } };
if (typeof ReadableStream !== 'undefined') {
  const proto = ReadableStream.prototype as unknown as Record<symbol | string, unknown>;
  if (!proto[Symbol.asyncIterator]) {
    const iter = async function* (this: RS) {
      const reader = this.getReader();
      try {
        for (;;) {
          const { done, value } = await reader.read();
          if (done) return;
          yield value;
        }
      } finally {
        reader.releaseLock();
      }
    };
    proto[Symbol.asyncIterator] = iter;
    if (!proto.values) proto.values = iter;
  }
}
export {};
